export default __webpack_public_path__ + "static/media/sql.8c53f465.png";